type AwardSealProps = {
  compact?: boolean;
  className?: string;
};

/**
 * Rendered representation of the BusinessRate Top 10 seal printed on the
 * 2026 award letter. Shared so the home page and the ratings page show the
 * same mark rather than two drifting versions of it.
 */
export default function AwardSeal({ compact = false, className = '' }: AwardSealProps) {
  return (
    <div
      className={`rounded-[2rem] border border-gold-300 bg-gradient-to-b from-white via-cream-50 to-gold-50 text-center shadow-[0_20px_60px_rgba(196,154,58,0.16)] ${
        compact ? 'px-6 py-7' : 'px-8 py-9'
      } ${className}`}
      role="img"
      aria-label="BusinessRate Top 10 Award Winner 2026 seal — Top Publisher in Los Angeles County"
    >
      <div
        className={`mx-auto mb-4 rounded-full bg-gold-500/10 border border-gold-300 flex items-center justify-center ${
          compact ? 'w-12 h-12' : 'w-16 h-16'
        }`}
      >
        <i className={`ri-trophy-line text-gold-600 ${compact ? 'text-lg' : 'text-2xl'}`}></i>
      </div>

      <div className="flex items-center justify-center gap-1 mb-3">
        {[1, 2, 3, 4, 5].map((star) => (
          <div key={star} className="w-4 h-4 flex items-center justify-center">
            <i className={`ri-star-fill text-gold-500 ${compact ? 'text-[8px]' : 'text-[10px]'}`}></i>
          </div>
        ))}
      </div>

      <p
        className={`font-black tracking-tight text-navy-900 leading-none ${
          compact ? 'text-3xl' : 'text-4xl md:text-5xl'
        }`}
      >
        TOP 10
      </p>
      <p className={`font-bold text-gold-600 tracking-[0.3em] mt-2 ${compact ? 'text-base' : 'text-xl'}`}>2026</p>
      <p
        className={`font-semibold uppercase tracking-[0.28em] text-navy-500 mt-3 ${
          compact ? 'text-[9px]' : 'text-[10px]'
        }`}
      >
        Award Winner
      </p>

      <div className={`border-t border-gold-200 ${compact ? 'mt-4 pt-4' : 'mt-6 pt-5'}`}>
        <p className={`font-bold text-navy-900 tracking-tight ${compact ? 'text-base' : 'text-lg'}`}>BusinessRate</p>
        <div className="flex items-center justify-center gap-1 mt-2 mb-2">
          {[1, 2, 3, 4, 5].map((star) => (
            <div key={star} className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-gold-400 text-[8px]"></i>
            </div>
          ))}
        </div>
        <p className="text-[9px] uppercase tracking-[0.18em] text-navy-500 leading-relaxed">
          Recognizing top performers.
          <br />
          Empowering business excellence.
        </p>
      </div>
    </div>
  );
}